import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import Image from 'next/image';
import appDownloadLinksStyles from './app-download-links.module.scss';

export const AppDownloadLinks = (): React.JSX.Element => {
  return (
    <div className={appDownloadLinksStyles.downloads}>
      <p className="font-bold text-center"
        data-test="download-app"
      >
        Download the App
      </p>
      <div className="flex justify-center">
        <CinemarkLink dataLinkCategory={AnalyticsPageCategories.FOOTER}
          dataLinkName="Download Google App"
          dataTest="download-google-app"
          // eslint-disable-next-line @stylistic/max-len
          href="https://play.google.com/store/apps/details?id=com.cinemark.mobile&amp;utm_source=cnk_website&amp;utm_medium=referral&amp;utm_campaign=web_footer_download_link"
          target="_blank"
        >
          <Image alt="Download the Cinemark app on the Google Play store"
            className="w-full max-w-[300px]"
            height={250}
            src="/img/google-play-badge_updated.png"
            width={646}
          />
        </CinemarkLink>
        <CinemarkLink dataLinkCategory={AnalyticsPageCategories.FOOTER}
          dataLinkName="Download Apple App"
          dataTest="download-apple-app"
          href="https://apps.apple.com/app/apple-store/id435965836?pt=501201&amp;ct=Web%20Footer&amp;mt=8"
          target="_blank"
        >
          <Image alt="Download the Cinemark app on the Apple App store"
            className="w-full max-w-[300px]"
            height={250}
            src="/img/apple-app-store-badge_updated.png"
            width={646}
          />
        </CinemarkLink>
      </div>
    </div>
  );
};
